import { AxiosError } from "axios";

export function getErrorMessage(error: unknown): string {
	// Handle Axios errors
	if ((error as AxiosError).isAxiosError) {
		const axiosError = error as AxiosError;

		if (axiosError.response) {
			const { data } = axiosError.response;

			// Return backend error details if any
			if (data) {
				if (typeof data === "string") {
					return data;
				} else if ((data as any).message) {
					return (data as any).message;
				} else {
					return JSON.stringify(data);
				}
			}
		}

		// No response from server
		if (axiosError.request) {
			return "No response from server. Please check your network connection.";
		}

		// Request setup failed
		return `Request error: ${axiosError.message}`;
	}

	// Non-Axios error
	if (error instanceof Error) {
		return error.message;
	}

	// Unknown error type
	return "An unknown error occurred.";
}
